import React, { useEffect, useState } from 'react';
import { Grid, Button, Box } from "@mui/material";
import { styles } from "./styles";
import { styles as inputStyles } from "common/inputStyles";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { CSVLink } from "react-csv";
import { Colors } from "assets/colors";

interface ActionButtons {
  label: string;
  icon?: any;
  onClickHandler: Function;
  buttonStyle: any;
}

interface DeviceEventTableHeaderProps {
  //actionButtons: Array<ActionButtons>;
  searchVal: string;
  setSearchVal: Function;
  data: any;
  tabs?: Array<ActionButtons>;
  withFilter?: boolean;
  csvLabel?: string;
  setShowCont?: any;
  setFormattedData?: any;
  setCheckedData?: any
  formattedData?: any;
  checkedData?: any;
}

const DeviceEventTableHeader: React.FC<DeviceEventTableHeaderProps> = ({ searchVal, setCheckedData, formattedData, setFormattedData, checkedData, setShowCont, setSearchVal, data, tabs, withFilter, csvLabel }) => {

  const [originalData, setOriginalData] = useState<any>(null);

  const transformUserRoles = (arr: any) => {
    let transformedArray: any = [];
    arr.forEach((obj: any) => {
      if (obj.hasOwnProperty('userRoleList')) {
        let transformedObj = { ...obj };
        if (transformedObj.hasOwnProperty('userId')) {
          delete transformedObj['userId'];
        }
        if (transformedObj.hasOwnProperty('timeZone')) {
          delete transformedObj['timeZone'];
        }
        if (transformedObj.hasOwnProperty('dateFormat')) {
          delete transformedObj['dateFormat'];
        }
        if (transformedObj.hasOwnProperty('numberFormat')) {
          delete transformedObj['numberFormat'];
        }
        if (transformedObj.hasOwnProperty('permissionCount')) {
          delete transformedObj['permissionCount'];
        }
        if (transformedObj.hasOwnProperty('recordNumber')) {
          delete transformedObj['recordNumber'];
        }
        if (transformedObj.hasOwnProperty('obsNumber')) {
          delete transformedObj['obsNumber'];
        }
        if (transformedObj.hasOwnProperty('Event Timestamp')) {
          delete transformedObj['Event Timestamp'];
        }
        if (transformedObj.hasOwnProperty('Image Filename')) {
          delete transformedObj['Image Filename'];
        }
        if (transformedObj.hasOwnProperty('Image Status')) {
          delete transformedObj['Image Status'];
        }
        if (transformedObj.hasOwnProperty('roleId')) {
          delete transformedObj['roleId'];
        }
        if (transformedObj.hasOwnProperty('truckId')) {
          delete transformedObj['roleId'];
        }
        const userRoles = transformedObj['userRoleList'].map((roleObj: any) => roleObj['roleName']);
        transformedObj['userRoleList'] = userRoles.join(', ');
        transformedArray.push(transformedObj);
        //console.log(transformedObj)
      }
    });

    if (transformedArray.length > 0) {
      setCheckedData(transformedArray);
    } else {
      setCheckedData(data);
    }
  }

  const transformKey = (key: string) => {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const transformObjectKeys = (obj: any) => {
    const transformedObj = Object.keys(obj).reduce((acc, key) => {
      const transformedKey = transformKey(key);
      return { ...acc, [transformedKey]: obj[key] };
    }, {});
    return transformedObj;
  };

  useEffect(() => {
    if (searchVal && searchVal.length > 0) {
      let searchValue = searchVal.toLowerCase();
      if (checkedData !== null && checkedData.length > 0) {
        let transformedArray = checkedData.map((obj: any) => transformObjectKeys(obj));
        console.log(transformedArray)
        let eventRptData: any = [];
        for (var i = 0; i < transformedArray.length; i++) {
          let eventorderObj: any = {};
          eventorderObj["Device ID"] = transformedArray[i]["Host Name"];
          eventorderObj["Service Provider Name"] = transformedArray[i]["Service Provider Name"];
          eventorderObj["Segment Name"] = transformedArray[i]["Truck Segment Name"];
          eventorderObj["RFID Tag"] = transformedArray[i]["Rfid Tag"];
          eventorderObj["Truck Number"] = transformedArray[i]["Truck No"];
          eventorderObj["Event Name"] = transformedArray[i]["Event Name"];
          eventorderObj["Event Timestamp"] = transformedArray[i]["Event Timestamp"];
          eventorderObj["Received Timestamp"] = transformedArray[i]["Received Timestamp"];
          eventorderObj["Latitude"] = transformedArray[i]["Latitude"];
          eventorderObj["Longitude"] = transformedArray[i]["Longitude"];
          eventorderObj["Address"] = transformedArray[i]["Address"];
          eventorderObj["Observation Number"] = transformedArray[i]["Obs Number"];
          eventorderObj["Observation Description"] = transformedArray[i]["Obs Desc"];
          eventorderObj["Image Url"] = transformedArray[i]["Image Url"];
          eventorderObj["Image-2 Url"] = transformedArray[i]["Image-2 Url"];

          let jsonString = JSON.stringify(transformedArray[i]);
          if (jsonString.toLowerCase().includes(searchValue)) {
            eventRptData.push(eventorderObj);
          }
        }
        setFormattedData(eventRptData);
      }
    }
    else {
      setFormattedData(originalData);
    }
  }, [searchVal]);

  useEffect(() => {
    if (checkedData !== null && checkedData.length > 0) {
      let transformedArray = checkedData.map((obj: any) => transformObjectKeys(obj));
      console.log(transformedArray)
      let eventRptData: any = [];
      for (var i = 0; i < transformedArray.length; i++) {
        let eventorderObj: any = {};
        eventorderObj["Device ID"] = transformedArray[i]["Host Name"];
        eventorderObj["Service Provider Name"] = transformedArray[i]["Service Provider Name"];
        eventorderObj["Segment Name"] = transformedArray[i]["Truck Segment Name"];
        eventorderObj["RFID Tag"] = transformedArray[i]["Rfid Tag"];
        eventorderObj["Truck Number"] = transformedArray[i]["Truck No"];
        eventorderObj["Event Name"] = transformedArray[i]["Event Name"];
        eventorderObj["Event Timestamp"] = transformedArray[i]["Event Timestamp"];
        eventorderObj["Received Timestamp"] = transformedArray[i]["Received Timestamp"];
        eventorderObj["Latitude"] = transformedArray[i]["Latitude"];
        eventorderObj["Longitude"] = transformedArray[i]["Longitude"];
        eventorderObj["Address"] = transformedArray[i]["Address"];
        eventorderObj["Observation Number"] = transformedArray[i]["Obs Number"];
        eventorderObj["Observation Description"] = transformedArray[i]["Obs Desc"];
        eventorderObj["Image Url"] = transformedArray[i]["Image Url"];
        eventorderObj["Image-2 Url"] = transformedArray[i]["Image-2 Url"];
        eventRptData.push(eventorderObj);
      }
      setFormattedData(eventRptData);
      setOriginalData(eventRptData);
    }
  }, [checkedData]);

  useEffect(() => {
    if (data.length > 0) {
      transformUserRoles(data);
    }
  }, [data]);

  return (
    <Grid item xs={12} sx={{ ...styles.container, justifyContent: tabs ? "space-between" : "flex-end" }} style={{ margin: '0px' }}>
      {
        tabs &&
        <Grid sx={styles.buttonContainer}>
          {tabs.map((t, i) =>
            <Button key={i} sx={{ ...styles.buttons, ...t.buttonStyle, marginRight: 0 }} onClick={() => t.onClickHandler()}>
              {t.icon && t.icon}
              {t.label}
            </Button>
          )}
        </Grid>
      }
      <Grid sx={styles.buttonContainer}>
        <CSVLink data={formattedData || []} style={{ textDecoration: 'none' }} filename={csvLabel ? csvLabel : 'download.csv'}>
          <Button sx={{ ...styles.buttons, backgroundColor: Colors.Purple }}>
            <FileDownloadOutlinedIcon sx={{ marginRight: ".5rem" }} />
            Download CSV
          </Button>
        </CSVLink>
        <Box sx={inputStyles.searchContainer}>
          <SearchOutlinedIcon sx={{ marginLeft: ".5rem" }} />
          <input type="text" placeholder='Search' value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default DeviceEventTableHeader;
